module.exports = __webpack_public_path__ + "img/nav_resume.87ee5095.svg";